<template>

  <v-dialog v-model="value" persistent
            :width="width" :height="height"
            :min-width="minWidth" :min-height="minHeight"
            :max-width="maxWidth" :max-height="maxHeight"
            @keydown.esc="keyPress_esc()">
    <v-card>

      <v-card-title>
        <slot name="header"/>
      </v-card-title>

      <v-card-text>
        <slot name="content"/>
      </v-card-text>

      <v-card-actions>
        <v-container>
          <v-row style="text-align: center;">
            <slot name="actions-left"></slot>
            <v-col>
              <v-btn @click.native="btnCancel_click()" :disabled="disabled"> {{label_cancel}}</v-btn>
            </v-col>
            <slot name="actions"></slot>
            <v-col>
              <v-btn @click.native="btnAccept_click()" :disabled="disabled">{{label_accept}}</v-btn>
            </v-col>
            <slot name="actions-right"></slot>
          </v-row>
        </v-container>
      </v-card-actions>

    </v-card>
  </v-dialog>

</template>

<script>

	import isPromise from 'is-promise';
	import {VDialog, VSelect, VTextField} from 'vuetify'

	export default {
		name: "default-dialog",
		components: {
			VDialog, VTextField, VSelect,
		},

		data: function () {
			return {
				inputs: {
					name: null,
					instrument: null,
					notes: null,
				}
			}
		},

		props: {
			value: {type: Boolean, default: false,},

			width: {type: String, default: null,},
			height: {type: String, default: null,},
			minWidth: {type: String, default: null,}, // min-width
			minHeight: {type: String, default: null,}, // min-height
			maxWidth: {type: String, default: null,},  // max-width
			maxHeight: {type: String, default: null,}, // max-height

			disabled: {type: Boolean, default: false,},

			label_accept: {type: String, default: "OK",},
			label_cancel: {type: String, default: "Cancel",},
		},

		methods: {
			/**
			 * диалог не может закрыть себя сам,
			 * так как видимостью управляет внешний компонент,
			 * а свойства (props) изнутри менять нельзя
			 */
			close: function () {
				this.$emit('closing')
			},

			/**
			 * В событии accepted передается обратный вызов .result,
			 * который нужно вызвать с аргументом true, чтобы закрыть диалог.
			 * Такой подвыверт, так как в Vue не предусмотрен
			 * возврат результата из обработчиков событий
			 */
			dialogAccept: function () {

				const close_do = function (res) {
					if (typeof(res) !== 'boolean')
						throw new TypeError('dialog result must be of type boolean')

					if (res)
						this.close(res)
				}.bind(this)

				try {
					this.$emit(
						'accepted',
						{
							result: function (close_res) {

								// обычно действие по диалогу возвращает Promise
								if (isPromise(close_res)) {
									close_res.then((res) => close_do(res))
								}
								else if (typeof(close_res) === 'boolean') {
									close_do(close_res)
								} else
									throw new TypeError("dialog result(close) requires boolean or Promise arg", close)

							}
						})
				} catch (ex) {
					console.error(ex.toString())
				}
				// this.close()
			},

			dialogCancel: function () {
				this.disabled = false
				this.error = false

				this.$emit('cancelled')
				this.close()
			},


			// -- handle controls' events --

			btnAccept_click: function (e) {
				this.dialogAccept()
			},

			btnCancel_click: function (e) {
				this.dialogCancel()
			},

			keyPress_esc: function (e) {
				this.dialogCancel()
			}
		}
	}
</script>

<style scoped>

</style>